import { render, staticRenderFns } from "./MainItineraryContent.vue?vue&type=template&id=dbf47560&"
import script from "./MainItineraryContent.vue?vue&type=script&lang=js&"
export * from "./MainItineraryContent.vue?vue&type=script&lang=js&"
import style0 from "./MainItineraryContent.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports